import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useSiteConfig } from "../context/SiteConfigContext";

/**
 * Full-width sale hero strip shown on the homepage when a site-wide discount
 * is active. Renders nothing when the sale is off.
 */
const SaleHeroBanner = () => {
  const { discount, loaded } = useSiteConfig();
  if (!loaded || !discount?.active) return null;

  return (
    <section
      data-testid="sale-hero-banner"
      className="relative overflow-hidden bg-[var(--espresso)] text-[var(--cream)]"
    >
      <div className="absolute inset-0 opacity-[0.07] pointer-events-none select-none" aria-hidden="true">
        <p className="absolute -top-8 -left-4 font-serif-display text-[22rem] leading-none italic text-[var(--copper)]">
          −{Math.round(discount.percent)}%
        </p>
      </div>
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <p className="text-xs tracking-[0.3em] uppercase text-[var(--copper)] mb-5 flex items-center gap-2">
          <Sparkles className="w-4 h-4" /> Limited time
        </p>
        <h2 className="font-serif-display text-5xl lg:text-7xl leading-[1.05] max-w-3xl">
          {discount.message || `${discount.percent}% off every piece`}
        </h2>
        <p className="mt-6 text-[var(--cream)]/70 max-w-xl leading-relaxed">
          Every lamp and object in the studio is {Math.round(discount.percent)}% off — applied automatically, no code needed. Complimentary shipping on orders over ₹2,500.
        </p>
        <Link
          to="/shop"
          data-testid="sale-hero-cta"
          className="mt-10 inline-flex items-center gap-3 bg-[var(--copper)] text-white px-10 h-14 text-xs tracking-[0.25em] uppercase hover:bg-[var(--copper)]/90 transition-colors"
        >
          Shop the sale
        </Link>
      </div>
    </section>
  );
};

export default SaleHeroBanner;
